import { handleSetMoreHeight } from "./setHeights";

export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperPhones = new Swiper('.swiper-phones', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next.phones',
      prevEl: '.swiper-button-prev.phones'
    },
  });

  const swiperNewModels = new Swiper ('.swiper-new-model', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.new-model',
      prevEl: '.swiper-button-prev.new-model',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.new-model',
      dynamicBullets: true,
      clickable: true,
    },
    on: {
      init:() => {
        handleSetMoreHeight('.js-car-name', 0);
      },
    },
  });

  const swiperDirectSales = new Swiper ('.swiper-direct-sale', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.direct-sale',
      prevEl: '.swiper-button-prev.direct-sale',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.direct-sale',
      dynamicBullets: true,
      clickable: true,
    },
    on: {
      init:() => {
        handleSetMoreHeight('.js-sales-title', 0);
        handleSetMoreHeight('.js-direct-sale-description', 0);
      },
    },
  });

  const swipersDropdownNewModels = document.querySelectorAll('.drop-model');

  swipersDropdownNewModels.forEach((drop) => {
    let category = drop.getAttribute('data-ref');

    new Swiper (drop, {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow: true,
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: `.drop-next-${category}`,
        prevEl: `.drop-prev-${category}`,
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      }
    });
  });

  const swiperNewModelVerson = new Swiper ('.swiper-new-model-version', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.version',
      prevEl: '.swiper-button-prev.version',
    },
    pagination: {
      el: '.swiper-pagination.version',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 6,
        spaceBetween: 30,
      },
    },
  });

  const swiperLocations = new Swiper('.swiper-locations', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.locations',
      prevEl: '.swiper-button-prev.locations',
    },
    pagination: {
      el: '.swiper-pagination.locations',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      }
    },
  });

  const swiperPromotion = new Swiper ('.swiper-promotion', {
    slidesPerView: 1,
    watchOverflow: true,
    observer: true,
    navigation: {
      nextEl: '.swiper-button-next.promotion',
      prevEl: '.swiper-button-prev.promotion',
    },
    pagination: {
      el: '.swiper-pagination.promotion',
      clickable: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },

      1366: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  const swiperCategories = new Swiper ('.swiper-categories', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next.categories',
      prevEl: '.swiper-button-prev.categories',
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });

  const swiperAwards = new Swiper ('.swiper-awards', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.awards',
      prevEl: '.swiper-button-prev.awards',
    },
    pagination: {
      el: '.swiper-pagination.awards',
      clickable: true,
    },
    on: {
      init:() => {
        handleSetMoreHeight('.js-awards-title', 0);
        handleSetMoreHeight('.js-awards-subtitle', 0);
      },
    },
  });

  const swiperHighlightsTabs = new Swiper ('.swiper-highlights-tabs', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next.highlights-tabs',
      prevEl: '.swiper-button-prev.highlights-tabs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
    },
  });

  const swiperConsortiumTabs = new Swiper ('.swiper-consortium-tabs', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next.consortium',
      prevEl: '.swiper-button-prev.consortium',
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
      },
    },
  });

  const blogInternalRelatedSwiper = new Swiper('.blog-internal-related-slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 1,
    watchOverflow: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.blog-internal',
      prevEl: '.swiper-button-prev.blog-internal',
    },
    pagination: {
      el: '.swiper-pagination.blog-internal',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });

  const usedModelInternalStampSwiper = new Swiper('.used-model-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const usedModelInternalThumbsSwiper = new Swiper('.used-model-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const usedModelInternalSwiper = new Swiper('.used-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: usedModelInternalThumbsSwiper,
    },
  });

  const usedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
    clickable: true,
    slidesPerView: 1,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });
}
